<div class="mat-typography">
  <div class="dialog-header">
    Are you sure you want to delete selected area{{
      data?.areas?.size !== 1 ? "s" : ""
    }}?
  </div>

  <div class="horizontal-separator"></div>

  <div class="dialog-container">
    This will permanently remove it from the list.

    <div *ngIf="showDryRun && dryRunResult" class="dry-run-result">
      <h4>Preview:</h4>
      <p>{{ dryRunResult.message }}</p>
      <p *ngIf="dryRunResult.deleted_ids?.length">
        Areas to be deleted: {{ dryRunResult.deleted_ids.length }}
      </p>
    </div>
  </div>
</div>
<div class="button-row">
  <button mat-button mat-dialog-close class="frmg-secondary-button">
    Cancel
  </button>
  <button
    mat-button
    class="frmg-secondary-button"
    [disabled]="isLoading"
    (click)="previewDelete()"
  >
    Preview
  </button>
  <button
    mat-button
    class="frmg-primary-button"
    [disabled]="isLoading"
    cdkFocusInitial
    (click)="delete()"
  >
    Delete
  </button>
</div>
